module.exports = __webpack_public_path__ + "img/BAWS_Staff5_1_1.425f93e2.png";